<template>
  <div class="paper-list" v-if="!loading">
    <exam-header :canClickLogo="true"></exam-header>
    <main class="paper-list_main">
      <div class="paper-list_hd">
        <img class="fit-img" src="@/common/images/student/bg_paper_hd.png" alt="">
        <div class="history-btn" @click="goHistory"><span/>我的考试记录</div>
      </div>
      <article class="paper-list_content">
        <div class="exam-calendar-section">
          <div class="calendar">
          <div
            v-for="(d, idx) in calendarDays"
            :key="d.time"
            :class="['calendar-item', { active: idx === selectedCalendarIndex } ]"
            @click="onCalendarClick(idx)"
          >
            <div class="calendar-week">{{ d.week }}</div>
            <div class="calendar-date" v-if="!d.isToday">({{ d.dateText }})</div>
          </div>
        </div>
          <div class="calendar_btn" @click="handShowCalendarModal"></div>
        </div>
        <section class="list" v-if="hasExams">
          <div v-for="(item,index) in Object.keys(paperList)" :key="index">
            <div class="list-item" v-if="paperList[item].length > 0">
              <div :class="['list-item_title',item.toLowerCase()]" v-if="paperList[item].length > 0"><span></span>{{paperListStatusMap[item]}}</div>
              <div class="paper-card_box">
                <exam-paper-card
                    class="paper-list_item"
                    v-for="list in paperList[item]"
                    :key="list.id"
                    :detail="list"
                    @start-exam="handleStartExam"
                    @continue-exam="handleContinueExam"
                    @show-grade="handleShowGrade"
                    @device-test="handleDeviceTest"
                ></exam-paper-card>
              </div>
            </div>
          </div>

        </section>
        <main class="paper-list_empty" v-else>
          <img class="paper-list_empty-img" src="@/common/images/empty_img.png" alt="">
          <div class="paper-list_empty-tip">当日暂时没有考试安排喔～</div>
          <div class="paper-list_empty-tip">可以前往考试日历查看更多考试排期</div>
          <div class="paper-list_empty-btn" @click="goHistory">查看考试日历</div>
        </main>
      </article>
    </main>

    <user-info-modal
      v-if="showUserInfoModal"
      :userInfo="userIdentity"
      @save="handleUserInfoSave"
    ></user-info-modal>

    <!-- 考试开始倒计时弹窗 -->
    <base-modal
      v-if="timerModalConfig.show"
      cancelText="退出考试"
      okText="直接考试"
      :showClose="false"
      @cancel="handleTimerModalCancel"
      @ok="goToExam"
      >
      <div slot="title">考试即将开始(<span class="fc-red">{{timerModalConfig.countdown}}</span>)...</div>
      <div slot="content">
        <p>{{timerModalConfig.tip}}</p>
        <p>点击下方按钮，直接开始考试</p>
      </div>
    </base-modal>

    <!-- 成绩弹窗 -->
    <exam-grade-modal
      v-if="gradeModalConfig.show"
      :record = "gradeModalConfig.record"
      @close="handleGradeModalClose"
      ></exam-grade-modal>
    <!--考试日历弹窗-->
    <exam-calendar-modal
      v-show="showCalendarModal"
      :show="showCalendarModal"
      @close="handleCloseCalendarModal"
    ></exam-calendar-modal>
    <!-- <device-test-modal
      v-if="showDeviceTestModal"
      @close="showDeviceTestModal=false"
      @success="showDeviceTestModal=false"
    ></device-test-modal> -->
  </div>
</template>

<script>
import {getSystemTime, mathHomeUrl} from '@/api/api';
import { getExamRoundList } from '@/api/qzStudent';
import { getUser, saveUser} from '@/api/user';
import BaseModal from '@/components/baseModal.vue';
import ExamHeader from '@/components/examHeader.vue';
import UserInfoModal from './components/userInfoModal.vue';
import ExamPaperCard from './components/examPaperCard.vue';
import ExamGradeModal from './components/examGradeModal.vue';
import ExamCalendarModal from './components/examCalendarModal.vue';
// import DeviceTestModal from '@/components/deviceTestModal.vue';
import dayjs from 'dayjs';

export default {
  name: 'PaperList',
  components: {
    ExamCalendarModal,
    ExamHeader,
    ExamPaperCard,
    UserInfoModal,
    BaseModal,
    ExamGradeModal,
    // DeviceTestModal,
  },
  data() {
    return {
      loading: true,
      paperList: [],
      pageData:[],
      showUserInfoModal: false,
      userIdentity: null,
      gradeModalConfig: {
        show: false,
      },
      timerModalConfig: {
        countdown: 10,
        show: false,
        examId: null
      },
      paperListStatusMap:{
        'RUNNING':'正在进行',
        'NOT_START':'即将开始',
        'OVER':'考试结束'
      },
      // 日历相关
      calendarDays: [], // 从今日考试起往后7天
      selectedCalendarIndex: 0,
      showDeviceTestModal: false,
      showCalendarModal: false, // 控制考试日历弹窗显示
    }
  },
  computed: {
    hasExams() {
      return Object.values(this.paperList).some(arr => arr.length > 0);
    }
  },
  created() {
    this.checkUser();
    this.initCalendar().then(() => {
      this.initPagerList();
    });
  },
  methods: {
    goHistory() {
      this.$router.push({
        name:'historyDetail'
      })
    },
    handShowCalendarModal() {
      this.showCalendarModal = true;
      document.body.style.overflowY = 'hidden';
    },
    handleCloseCalendarModal() {
      this.showCalendarModal = false;
      document.body.style.overflowY = 'initial';
    },
    async initCalendar() {
      const serverNow = await getSystemTime();
      const startOfToday = dayjs(serverNow).startOf('day');
      const weekMap = ['周日','周一','周二','周三','周四','周五','周六'];
      const days = [];
      for (let i = 0; i < 7; i++) {
        const d = startOfToday.add(i, 'day');
        const isToday = i === 0;
        days.push({
          time: d.valueOf(),
          week: isToday ? '今日考试' : weekMap[d.day()],
          dateText: d.format('MM.DD'),
          fullText: `${isToday ? '今日考试' : weekMap[d.day()]} (${d.format('MM.DD')})`,
          isToday,
        });
      }
      this.calendarDays = days;
      this.selectedCalendarIndex = 0;
    },
    // 计算当前选中日期的开始与结束时间（毫秒）
    getSelectedDayRange() {
      const selected = this.calendarDays[this.selectedCalendarIndex];
      if (!selected) return {};
      const day = dayjs(selected.time);
      return {
        startTime: day.startOf('day').valueOf(),
        endTime: day.endOf('day').valueOf(),
      };
    },
    onCalendarClick(idx) {
      if (idx === this.selectedCalendarIndex) return;
      this.selectedCalendarIndex = idx;
      this.getPaperList();
    },
    async formatPaperList  (paperList) {
      const now = await getSystemTime();  //当前服务器时间
      /**
       * 请按照 数据中 startTime 以及 rule.costTime(考试时长) 判断当前考试的状态对paperList数据进行分类
       *  输出格式要求 {'RUNNING':[], 'NOT_START':[], 'OVER':[]}
       * */
      const result = { RUNNING: [], NOT_START: [], OVER: [] };
      if (!Array.isArray(paperList) || paperList.length === 0) {
        return result;
      }

      paperList.forEach((item) => {
        const startTime = item?.startTime;
        const costTimeMinute = item?.rule?.costTime || 0; // 分钟
        const endTime = (typeof startTime === 'number')
          ? startTime + costTimeMinute * 60 * 1000
          : Number.NEGATIVE_INFINITY; // 若无有效开始时间，直接视为已结束

        if (typeof startTime !== 'number') {
          result.OVER.push(item);
          return;
        }

        if (now < startTime) {
          result.NOT_START.push(item);
        } else if (now < endTime) {
          result.RUNNING.push(item);
        } else {
          result.OVER.push(item);
        }
      });

      // 对每组数据进行排序
      Object.keys(result).forEach(status => {
        if (status === 'RUNNING') {
          // RUNNING状态：按开始时间正序排序，开始时间相同时按order倒序排序（order越大越靠前）
          result[status].sort((a, b) => {
            if (a.startTime === b.startTime) {
              return (b.order || 0) - (a.order || 0);
            }
            return a.startTime - b.startTime;
          });
        } else {
          // 其他状态：按结束时间正序排序，结束时间相同时按order倒序排序（order越大越靠前）
          result[status].sort((a, b) => {
            const aEndTime = a.startTime + (a.rule?.costTime || 0) * 60 * 1000;
            const bEndTime = b.startTime + (b.rule?.costTime || 0) * 60 * 1000;

            if (aEndTime === bEndTime) {
              return (b.order || 0) - (a.order || 0);
            }
            return aEndTime - bEndTime;
          });
        }
      });

      return result;
    },
    checkUser() {
      getUser().then((res) => {
        this.userIdentity = {
          ...res,
          schoolId: res.schoolId === -1 ? null : res.schoolId,
        };
        if (!res || !res.schoolId || !res.grade || !res.idCardNo || res.schoolId === -1) {
          this.showUserInfoModal = true;
        }
      })
    },
    handleUserInfoSave(data) {
      // this.showUserInfoModal = false;
      saveUser(data).then((res) => {
        if (res?.body?.result) {
          this.$message.success('保存成功');
          // this.getPaperList(); // 更新完学校之后，刷新考试列表
          window.location.reload();
        }
      })
    },
    getPaperList() {
      const { startTime, endTime } = this.getSelectedDayRange();
      return getExamRoundList({ startTime, endTime }).then(async (res) => {
        if (res?.code === 200) {
          this.pageData = res.body.examRounds || [];
          this.paperList = await this.formatPaperList(res.body.examRounds || []);
          console.log(this.paperList,'=========');
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    initPagerList() {
      this.loading = true;
      this.getPaperList()
    },
    handleStartExam(detail) {
      if (detail.invigilateStatus) {
        this.handleDeviceTest(`examId=${detail.courseExamId}&roundId=${detail.id}&hasCheck=1`, false);
        return;
      }
      this.timerModalConfig = {
        show: true,
        countdown: 10,
        tip: '倒计时结束后，将开始考试，请做好准备',
        detail,
      }
      this._startTimer();
    },
    _startTimer() {
      this.timer = setInterval(() => {
        this.timerModalConfig.countdown--;
        if (this.timerModalConfig.countdown === 0) {
          this.goToExam();
        }
      }, 1000);
    },
    goToExam() {
      const { courseExamId, id } = this.timerModalConfig.detail;
      // this.$router.push({
      //   name: 'paperDetail',
      //   query: {
      //     examId: courseExamId,
      //     roundId: id,
      //   },
      // })
      window.location.href = `${mathHomeUrl}exam/normal?examId=${courseExamId}&roundId=${id}`;
      this.handleTimerModalCancel();
    },
    handleTimerModalCancel() {
      clearInterval(this.timer);
      this.timerModalConfig = {
        show: false
      }
    },
    handleContinueExam(detail) {
      if (detail.invigilateStatus) {
        // ${mathHomeUrl}exam/monitor?roundId=${id}&examId=${courseExamId}
        this.handleDeviceTest(`examId=${detail.courseExamId}&roundId=${detail.id}&hasCheck=1`, false);
        return;
      }
      let url =`${mathHomeUrl}exam/normal?id=${detail.userCourseExamRelationInstance.id}`
      window.location.href = url;
    },
    handleShowGrade(userExamInfo) {
      this.gradeModalConfig = {
        show: true,
        record: userExamInfo,
      }
    },
    handleGradeModalClose() {
      this.gradeModalConfig = {
        show: false
      }
    },
    handleDeviceTest(params='', newWindow=true) {
      window.open(`${mathHomeUrl}exam/deviceTest${params ? `?${params}` : ''}`, newWindow ? '_blank' :'_self');
    }
  }
}
</script>

<style lang="less" scoped>
.paper-list {
  text-align: left;
  background: #EDE4DA;
  min-height: 100%;
  padding-top: 96px;
  padding-bottom: 56px;
  box-sizing: border-box;
  // min-width: 1200px;
  overflow: auto;
  &_main {
    width: 1200px;
    border-radius: 20px;
    margin: 0 auto;
    background-color: #fff;
    min-height: calc(100vh - 160px);
    box-sizing: border-box;
  }
  &_hd{
    position: relative;
    height: 100px;
    .history-btn{
      position: absolute;
      right: 48px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 136px;
      height: 32px;
      background:#F5F6F9;
      font-size: 14px;
      border-radius: 8px;
      cursor: pointer;
      span{
        width: 15px;
        height: 15px;
        margin-right: 5px;
        background: url("@/common/images/ic_history.png") center / contain no-repeat;
      }
    }
  }
  &_content {
    padding: 30px 80px;
    .info {
      font-size: 14px;
      line-height: 1.5;
      margin-bottom: 28px;
      &-title {
        color: #4E5969;
        font-weight: 500;
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        &::before {
          content: '';
          display: inline-block;
          width: 3px;
          height: 14px;
          background-color: #BD9F68;
          margin-right: 8px;
          border-radius: 90px;
        }
      }
      &-desc {
        color: #86909C;
      }
    }
    .list {
      .list-item{
        margin-top: 36px;
        .paper-card_box{
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          gap: 20px;
        }
        &_title{
          display: flex;
          align-items: center;
          font-size: 20px;
          color: #1D2129;
          margin-bottom: 16px;
          font-weight: 500;
          span{
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-right: 8px;
          }
          &.running{
            span{
              background: #E60012;
            }
          }
          &.not_start{
            span{
              background: #F1ACB1;
            }
          }
          &.over{
            span{
              background: #E5E6EB;
            }
          }
        }
      }
    }
    .exam-calendar-section{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .calendar_btn{
      width: 24px;
      height: 24px;
      background: url("@/common/images/ic_calendar.png") center / contain no-repeat;
      margin-left: 15px;
      margin-bottom: 12px;
      cursor: pointer;
    }
    .calendar{
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      justify-content: space-between;
      width: 100%;
      .calendar-item{
        color:#86909C;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        transition: all .2s ease;
        font-size: 18px;
        .calendar-week{
          height: 36px;
          line-height: 36px;
        }
        .calendar-date{
          margin-left: 8px;
        }
        &.active{
          font-weight: 500;
          color: #1D2129;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            bottom: -4px;
            left: 50%;
            transform: translateX(-50%);
            width: 64px;
            height: 5px;
            background: #E60012;
            border-radius: 90px;
          }
        }
      }
    }
  }
  &_empty {
    width: 100%;
    background-color: #fff;
    border-radius: 20px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: calc(100vh - 160px);
    padding: 130px 0;
    box-sizing: border-box;
    &-img {
      width: 180px;
      margin-bottom: 16px;
    }
    &-tip {
      font-size: 18px;
      color: #000000E5;
      font-weight: 500;
    }
    &-btn{
      width: 240px;
      height: 48px;
      background: #E60012;
      border-radius: 24px;
      color: #fff;
      font-size: 18px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 48px;
      cursor: pointer;
    }
  }
}
</style>